import { createContext, type ReactNode, useContext } from 'react';

const ChartTitleContext = createContext<string | undefined>(undefined);

interface ChartTitleProviderProps {
    /**
     * Already translated. The visible title of the card or panel the chart sits in. Left
     * empty, the title of an enclosing card still applies.
     */
    title: string | undefined;
    children: ReactNode;
}

/**
 * Hands a card's visible title to the charts inside it, so each chart canvas can be named
 * after it without every caller threading the title down to the chart wrapper.
 */
export function ChartTitleProvider(props: ChartTitleProviderProps) {
    const { title, children } = props;
    const enclosingTitle = useContext(ChartTitleContext);
    const value = title !== undefined && title !== '' ? title : enclosingTitle;
    return <ChartTitleContext.Provider value={value}>{children}</ChartTitleContext.Provider>;
}

/** The title of the nearest card or panel that provides one. */
export function useChartTitle(): string | undefined {
    return useContext(ChartTitleContext);
}
